import { Component, OnInit, Input, EventEmitter, Output, HostListener } from '@angular/core';
import { NavData } from "../Models/NavData";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluation.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-ph-bhp-navbar',
  templateUrl: './ph-bhp-navbar.component.html',
  styleUrls: ['./ph-bhp-navbar.component.css'],
  animations: [
    trigger('expanded', [
      state('in', style({ opacity: 1, width: 'unset' })),
      state('out', style({ opacity: 0, display: 'none' })),
      transition('in => out', [
        animate('0.2s ease-out')
      ]),
      transition('out => in', [
        animate('0.4s ease-in')
      ])
    ])
  ]
})
export class PHBHPNavbarComponent implements OnInit {
  message: string;
  value;
  feedbackMenu = false;
  isExpand: Boolean;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  model = {
    name: '',
    email: '',
    mgs: ''
  }

  feedbackMgsMaxLength = 1000;
  @Input() userData;
  @Input() userRoleId: string = 'Institution User';
  @Input() navData: [NavData];
  constructor(public layoutService: PHBHPLayoutPackageService, public router: Router) {
  }

  clickedInside: boolean = false;
  @HostListener('click', ['$event'])
  clickInside(event: any) {
    if (event.target.classList.contains('open-tab')) {
      this.clickedInside = true;
    }
  }

  @HostListener('document:click')
  clickOutside() {
    if (this.clickedInside) {
      this.clickedInside = false;
    } else {
      this.navData.forEach((nav: any) => { nav.isHovered = false; });
      this.clickedInside = false;
    }
  }

  ngOnInit() {
  }

  ngOnChanges() {

  }

  navbarDeactive() { }

  getEventAppMenu(event) {
    this.feedbackMenu = event.val;
    this.layoutService.expandedMenu = false;
  }

  onSubmit(event) { }

  expandMenu() {
    this.layoutService.expandedMenu = !this.layoutService.expandedMenu;
    this.isExpand = !this.isExpand;
  }

  getIndex() {
    // Get current url
    let url = window.location.href;
    if (url.includes('totalConsumption')) {
      return 10;
    } else {
      return 15;
    }
  }

  isExpandedTab(tab: any) {
    return tab.isOpened;
  }

  toggleTab(tab: any, navData: any[], event: Event) {
    if (tab.isOpened) {
      tab.isOpened = false;
      return;
    }

    navData.forEach((aTab) => {
      aTab.isOpened = false;
    });

    tab.isOpened = !!tab.isOpened ? !tab.isOpened : true;
    if (event) {
      event.stopPropagation();
    }
  }

  isLinkActive(tab: any) {
    var tabLinks = [];
    tabLinks.push(tab.navUrl);
    if (tab.tabs) {
      tab.tabs.forEach((tab) => {
        tabLinks.push(tab.navUrl);
      });
    }

    return tabLinks.includes(this.router.url);
  }

  onNavItemClick(tab: any, navData: any[], event: Event) {
    if (!this.layoutService.expandedMenu) {
      if (tab.tabs && tab.tabs.length > 0) {
        if (!tab.isHovered) {
          navData.forEach((aNav) => { aNav.isHovered = false; });
          tab.isHovered = true;
        } else {
          tab.isHovered = false;
        }
      } else {
        navData.forEach((aNav) => { 
          aNav.isOpened = false; 
          aNav.isHovered = false;
        });

        this.router.navigate([tab.navUrl]);
      }
    } else {
      if (tab.tabs && tab.tabs.length > 0) {
        if (!tab.isOpened) {
          navData.forEach((aNav) => { aNav.isOpened = false; });
          tab.isOpened = true;
        } else {
          tab.isOpened = false;
        }
      } else {
          navData.forEach((aNav) => { 
            aNav.isOpened = false; 
            aNav.isHovered = false;
          });
  
          this.router.navigate([tab.navUrl]);
      }
    }
  }
}